import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	// mode:"history",//此处添加
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	},
	routes: [
		{
			path: '/login',
			name: 'Login',
			component: function (resolve) {
				require(['@/views/login/Login'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/weixinLogin',
			name: 'WeixinLogin',
			component: function (resolve) {
				require(['@/views/login/WeixinLogin'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/operating',
			name: 'Operating',
			component: function (resolve) {
				require(['@/views/operating/Operating'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/createTeam',
			name: 'CreateTeam',
			component: function (resolve) {
				require(['@/views/operating/CreateTeam'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/teamParticulars',
			name: 'TeamParticulars',
			component: function (resolve) {
				require(['@/views/operating/TeamParticulars'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/management',
			name: 'Management',
			component: function (resolve) {
				require(['@/views/operating/Management'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/addMember',
			name: 'AddMember',
			component: function (resolve) {
				require(['@/views/operating/AddMember'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/audit',
			name: 'Audit',
			component: function (resolve) {
				require(['@/views/operating/Audit'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/retreat',
			name: 'Retreat',
			component: function (resolve) {
				require(['@/views/operating/Retreat'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/setAdministrator',
			name: 'SetAdministrator',
			component: function (resolve) {
				require(['@/views/operating/SetAdministrator'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/remark',
			name: 'Remark',
			component: function (resolve) {
				require(['@/views/operating/Remark'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/setTeam',
			name: 'SetTeam',
			component: function (resolve) {
				require(['@/views/seting/SetTeam'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/closeCondition',
			name: 'CloseCondition',
			component: function (resolve) {
				require(['@/views/seting/CloseCondition'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/dissolve',
			name: 'Dissolve',
			component: function (resolve) {
				require(['@/views/seting/Dissolve'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/home',
			name: 'Home',
			component: function (resolve) {
				require(['@/views/home/Home'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/supplement',
			name: 'Supplement',
			component: function (resolve) {
				require(['@/views/account/Supplement'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/account',
			name: 'Account',
			component: function (resolve) {
				require(['@/views/account/Account'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/allexploits',
			name: 'Allexploits',
			component: function (resolve) {
				require(['@/views/exploits/Allexploits'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/listOne',
			name: 'ListOne',
			component: function (resolve) {
				require(['@/views/account/ListOne'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		// {
		// 	path: '/myaward',
		// 	name: 'Myaward',
		// 	component: function (resolve) {
		// 		require(['@/views/award/Myaward'], resolve)
		// 	},
		// 	meta: {
		// 		keepAlive: false
		// 	}
		// },
		// {
		// 	path: '/awardParticulars',
		// 	name: 'AwardParticulars',
		// 	component: function (resolve) {
		// 		require(['@/views/award/AwardParticulars'], resolve)
		// 	},
		// 	meta: {
		// 		keepAlive: false
		// 	}
		// },
		// {
		// 	path: '/rateAward',
		// 	name: 'RateAward',
		// 	component: function (resolve) {
		// 		require(['@/views/award/RateAward'], resolve)
		// 	},
		// 	meta: {
		// 		keepAlive: false
		// 	}
		// },
		{
			path: '/allocation',
			name: 'Allocation',
			component: function (resolve) {
				require(['@/views/award/Allocation'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/purchase',
			name: 'Purchase',
			component: function (resolve) {
				require(['@/views/purchase/Purchase'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/indent',
			name: 'Indent',
			component: function (resolve) {
				require(['@/views/purchase/Indent'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/exploits',
			name: 'Exploits',
			component: function (resolve) {
				require(['@/views/exploits/Exploits'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/recharge',
			name: 'Recharge',
			component: function (resolve) {
				require(['@/views/purchase/Recharge'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/platformLogin',
			name: 'PlatformLogin',
			component: function (resolve) {
				require(['@/views/login/PlatformLogin'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/swivelClamp',
			name: 'SwivelClamp',
			component: function (resolve) {
				require(['@/views/account/SwivelClamp'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/trunCardsDone',
			name: 'TrunCardsDone',
			component: function (resolve) {
				require(['@/views/account/TrunCardsDone'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/cards',
			name: 'Cards',
			component: function (resolve) {
				require(['@/views/account/Cards'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/customer',
			name: 'Customer',
			component: function (resolve) {
				require(['@/views/account/Customer'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/recordTheScreening',
			name: 'RecordTheScreening',
			component: function (resolve) {
				require(['@/views/account/RecordTheScreening'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/customerDetails',
			name: 'CustomerDetails',
			component: function (resolve) {
				require(['@/views/account/CustomerDetails'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/turnCardDetails',
			name: 'TurnCardDetails',
			component: function (resolve) {
				require(['@/views/account/TurnCardDetails'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/cardTransactions',
			name: 'CardTransactions',
			component: function (resolve) {
				require(['@/views/account/CardTransactions'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/fight',
			name: 'Fight',
			component: function (resolve) {
				require(['@/views/fight/Fight'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/recreation',
			name: 'Recreation',
			component: function (resolve) {
				require(['@/views/recreation/Recreation'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/giveReward',
			name: 'GiveReward',
			component: function (resolve) {
				require(['@/views/recreation/GiveReward'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/modification',
			name: 'Modification',
			component: function (resolve) {
				require(['@/views/recreation/Modification'], resolve)
			},
			meta: {
				keepAlive: false
			}
		},
		{
			path: '/',
			redirect: '/WeixinLogin'
		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js